<template>
  <div> 
    <audio controls="controls" hidden src="../../../assets/err.mp3" ref="erraudio"></audio>
    <audio controls="controls" hidden src="../../../assets/success.wav" ref="successaudio"></audio>
    <div class="item-info">
      <ul class="item-ul">
        <li class="item-li">
          <div class="item-left">
            <span
              ><span style="color: #000">原SKU：</span
              >{{ list.originalSKU }}</span
            >
          </div>
        </li>
        <li class="item-li">
          <div class="item-right">
            <span
              ><span style="color: #000">原SKU名称：</span
              >{{ list.originalProductName }}</span
            >
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span
              ><span style="color: #000">新SKU:</span>{{ list.newSKU }}</span
            >
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span
              ><span style="color: #000">新SKU名称：</span
              >{{ list.newProductName }}</span
            >
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span
              ><span style="color: #000">规格型号：</span>{{ list.model }}</span
            >
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span
              ><span style="color: #000">采购单：</span
              >{{ list.relationNo }}</span
            >
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span
              ><span style="color: #000">转换数量：</span
              >{{ list.quantity }}</span
            >
          </div>
        </li>
      </ul>
    </div>

    <div class="search-box">
      <!-- style="background-color:red;border-color:red;color:#fff;" -->
      <van-field
        size="small"
        v-model="scanLocationCode"
        placeholder="请扫描库位"
        right-icon="scan"
        clear-trigger="always"
        clearable
        @click-right-icon="scanSku"
        @keyup.13="getLocation()"
        @input="triggerSearch"
        @keyup="inputNum"
        ref="scanInp"
      />
      <button class="hidden" ref="searchBtn" @click="getLocation()"></button>
      <span style="font-size: 14px; color: red" v-if="showErrStr.length">{{
        showErrStr
      }}</span>
      <span style="font-size: 14px; color: green" v-if="successStr.length">{{
        successStr
      }}</span>
    </div>

    <div class="list">
      <van-row type="flex" justify="center" align="center">
        <van-col span="8">库位</van-col>
        <van-col span="8">库存数</van-col>
        <van-col span="8">转换数({{this.countchangeNum}})</van-col>
      </van-row>
      <div>
        <van-swipe-cell
          v-for="(item, index) in list.skuStorageCommonList"
          :key="index"
        >
          <div class="list-div" @click="openModel(item.locationCode)">
            <p>{{ item.locationCode }}</p>
            <p>{{ item.totalQty }}</p>

            <p>
              <input
                type="number"
                class="downInp"
                readonly
                v-model="item.changeNum"
              />
            </p>
          </div>
          <template #right>
            <van-button
              square
              type="danger"
              text="清零"
              @click="toDelete(index)"
            />
          </template>
        </van-swipe-cell>
      </div>
      <div class="submit-box">
        <p><button class="submit-btn" @click="submit">执行完成</button></p>

        <p>
          <button
            class="submit-btn"
            style="background-color: red"
            @click="refuseSubmitdialog"
          >
            审核拒绝
          </button>
        </p>
      </div>
    </div>

    <van-dialog
      v-model="show"
      :title="`库位 ${saveLocationCode}`"
      show-cancel-button
      confirmButtonText="确认"
      cancelButtonText="取消"
      @confirm="confirm"
    >
      <div style="padding: 5% 20%">
        <van-field
          type="digit"
          size="small"
          placeholder="请输入SKU数量"
          v-model="saveNum"
        />
      </div>
    </van-dialog>

    <van-dialog
      v-model="refuseSubmitshow"
      :title="`审批拒绝`"
      show-cancel-button
      confirmButtonText="提交"
      cancelButtonText="取消"
      @confirm="refuseSubmit"
    >
      <div style="padding: 5% 20%">
        <van-field
          type="textarea"
          size="small"
          placeholder="请输入拒绝原因"
          v-model="refuseReason"
        />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Toast,
  Empty,
  List,
  Loading,
  Checkbox,
  Tab,
  Tabs,
  SwipeCell,
  Col,
  Row,
  Button,
  Cell,
  Dialog,
} from "vant";
import {
  getLabelChangeSkuStorage,
  LablechangeCheckStorageAndStock,
  LabelChangeFinishSubmit,
  LabelChangeRefuseSubmit,
} from "@/api/mobile/changelabel_api";
import { mixins } from "../mobileMixins";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      list: {},
      scanLocationCode: "",
      show: false,
      saveLocationCode: "",
      saveNum: "",
      refuseReason: "",
      showErrStr: "",
      isAutoOpen: false,
      successStr: "",
      refuseSubmitshow: false,
      scanskuStorageCommon: {},
	   newskuStorageCommonList: [],
     countchangeNum:0,
     totle:0,
    };
  },
  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [List.name]: List,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Checkbox.name]: Checkbox,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [SwipeCell.name]: SwipeCell,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
  },
  mixins: [mixins],
  created() {
    this.init();
  },
  mounted() {
    // document.querySelector('.van-field__right-icon').style.color = '#ffffff'
    // document.querySelector('.van-field__control').style.color = '#ffffff'
  },
  methods: {
    ...mapMutations({
      saveMobileTitle: "saveMobileTitle",
    }),

    init() {
      this.saveMobileTitle(window.localStorage.mobileTitle);
      this.getList();
    },

    triggerSearch() {
      this.$refs.searchBtn.click();
    },

    getList() {
      const that = this;

      const { labelChangeID } = this.$route.query;

      const data = {
        labelChangeID,
      };

      getLabelChangeSkuStorage(data).then((res) => {
        if (res.status === 200) {
          const { response } = res;

          this.list = response;

          if (!response.labelChangeID) {
            Toast.clear();
            //Toast('已拣货完成，待打包')

            setTimeout(function () {
              that.$router.go(-1);
            }, 1500);
          }
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    openModel(code) {
      this.show = !this.show;
      this.saveLocationCode = code;
      this.isAutoOpen = false;
      this.successStr = "";
    },
    refuseSubmit() {
      const that = this;

      Toast.loading({
        message: "提交中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });
      const { labelChangeID } = this.list;
      var data = {
        LabelChangeID: labelChangeID,
        Remark: that.refuseReason,
      };

      LabelChangeRefuseSubmit(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.showsound(true);
          this.successStr = "";
          this.showErrStr = "";
          Toast.success(res.msg);
          this.getList();
        } else {
          this.showsound(false);
          Toast.fail(res.msg);
        }
      });
    },
    confirm() {

      this.list.skuStorageCommonList.forEach((item, i) => {
        if (item.locationCode === this.saveLocationCode) {
          if (this.saveNum > item.totalQty) {
            Toast("转化数不可大于库存数");
            this.saveNum = 0;
          }
          this.$set(
            this.list.skuStorageCommonList[i],
            "changeNum",
            this.saveNum || 0
          );
        }
      });
      const s = this.saveNum;
      if (this.isAutoOpen) {
        this.showErrStr = "";
        this.successStr = `库位 ${this.saveLocationCode} 扫入成功，数量${s}`;
      }
      this.saveNum = "";
   
    var arr2=[];
    this.list.skuStorageCommonList.forEach((item, index) => {
          if (item.changeNum) {
             arr2.push(item.changeNum);  
          };
      });
    this.countchangeNum = arr2.reduce((prev, cur) => Number(prev) + Number(cur));
     
    },

    toDelete(i) {
      this.countchangeNum=this.countchangeNum-this.list.skuStorageCommonList[i].changeNum;
      this.$set(this.list.skuStorageCommonList[i], "changeNum", 0);
   
      

    },

    refuseSubmitdialog() {
      this.refuseSubmitshow = true;
    },
     showsound(isSuccess){
      if(isSuccess)
      {
          this.$refs.successaudio.currentTime=0;
          this.$refs.successaudio.play();
      }
      else
      {
          this.$refs.erraudio.currentTime=0;
          this.$refs.erraudio.play();
      }
    },
    submit() {
      const that = this;
      const _warehouse = window.localStorage.warehouse
        ? JSON.parse(window.localStorage.warehouse)
        : this.warehouse;
      const warehouseID = _warehouse.warehouseId;

      let skuStorageList = [];

      const { labelChangeID, newProductID, originalProductID, quantity } =
        this.list;
      this.list.skuStorageCommonList.forEach((item, index) => {
        if (item.changeNum) {
          const { productID, locationCode, storageID, changeNum } = item;
          var _item = {
            productID: productID,
            locationCode: locationCode,
            storageID: storageID,
            changeNum: changeNum,
          };
          skuStorageList.push(_item);
        }
      });
      const data = {
        LabelChangeID: labelChangeID,
        NewProductID: newProductID,
        OriginalProductID: originalProductID,
        Quantity: quantity,
        SkuStorageList: skuStorageList,
      };

      //       var sumchannum = 0.0;
      //       skuStorageList.forEach((item, index) => {
      // 		  console.log('转化数量：'+item.changeNum);
      //         if (item.changeNum) {
      //           sumchannum=sumchannum+item.changeNum;
      //         }
      //       });
      //    console.log('转化数量：'+sumchannum);
      //       if (sumchannum <= 0) {
      //         Toast.fail("请录入转换数量");
      //       }
      //       if (sumchannum != quantity) {
      //         Toast.fail("转化数量!=总的转化数");
      //       }
      Toast.loading({
        message: "转换中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      LabelChangeFinishSubmit(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.showsound(true);
          this.successStr = "";
          this.showErrStr = "";
          Toast.success(res.msg);
          this.getList();
        } else {
          this.showsound(false);
          Toast.fail(res.msg);
        }
      });
    },

    scanSku() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.scanLocationCode = a.resultStr;
          that.getLocation();
        },
      });
    },

    getLocation() {
      let that = this;
      this.showErrStr = "";
      this.successStr = "";

      const data = {
        locationCode: this.scanLocationCode,
        productId: this.list.originalProductID,
      };

      LablechangeCheckStorageAndStock(data).then((res) => {
        if (res.status === 200 && res.success) {
          this.showErrStr = "";
          if (res.response.length === 1) {
            this.show = true;
            this.isAutoOpen = true;
            this.saveLocationCode = res.response[0].locationCode;
            that.scanskuStorageCommon = res.response[0];
            that.newskuStorageCommonList=this.list.skuStorageCommonList.filter(item => item.locationCode!=this.saveLocationCode)
			that.newskuStorageCommonList.unshift(that.scanskuStorageCommon);

			this.$set(this.list,'skuStorageCommonList',that.newskuStorageCommonList);

       
            //this.$set(this.list,'skuStorageCommonList',res.response)
            console.log("this.show", this.show);
          } else {
            //this.$set(this.list,'skuStorageCommonList',res.response)
          }
        } else {
          this.showErrStr = res.msg;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../style/mobile_common.less";
.item-info {
  padding: 10px;
  font-size: 14px;
  background-color: #f2f2f2;
  .item-ul {
    .item-li {
      display: flex;
      align-content: flex-start;
      & > div {
        white-space: nowrap;
        word-break: break-all;
        flex: 1;
        line-height: 25px;
        & > span {
          vertical-align: text-top;
          &:first-child {
            padding-right: 10px;
            width: 50%;
            display: inline-block;
          }
          &:last-child {
            color: #3d5064;
          }
        }
        & > p {
          line-height: 20px;
          vertical-align: middle;
          color: #3d5064;
          margin: 0;
        }
      }
    }
  }
}
.submit-box {
  position: static;
  margin: 20px 0;
}
.submit-btn {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 18px;
  border: 0;
  position: static;
  bottom: 2%;
}
.hidden {
  display: none;
}
.addInfo {
  position: absolute;
  right: 1%;
  color: #027db4;
}
.p-title {
  font-weight: 600;
  margin-bottom: 0;
  padding-left: 10px;
}
.search-box {
  text-align: center;
  padding: 3% 12% 1.5%;
}
::v-deep .van-col {
  text-align: center;
  background-color: #f2f2f2;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
}
.list {
  .list-div {
    display: flex;
    height: 43px;
    line-height: 43px;
    border-bottom: 1px solid #ccc;
    & > p {
      flex: 1;
      text-align: center;
      margin: 0;
      & > .downInp {
        width: 55%;
        border: 1px solid #ccc;
        height: 25px;
        line-height: 25px;
        text-align: center;
      }
    }
  }
}
.sign-photo-save {
  padding: 0 10px;
}
.photo {
  font-size: 14px;
}
</style>